import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
/*
 *                     NOTICE
 *            COPYRIGHT 2018 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbActionBarItem } from "abreact/incubator/ui/component/actionBar/AbActionBarItem";
import { AbActionMenuSubmenu } from "abreact/incubator/ui/component/actionBar/AbActionMenuSubmenu";
import { ActionBarMenuMachine } from "abreact/incubator/ui/component/actionBar/ActionBarMenuMachine";
import { BaseMachine } from "abreact/incubator/ui/machine/BaseMachine";
import { createReactionName } from "abreact/incubator/ui/utils/MobXUtils";
import { Assert } from "abweb/utils/Assert";
import { ClassUtils } from "abweb/utils/ClassUtils";
import { action, computed, observable, reaction, makeObservable } from "mobx";

/**
 * Machine for a Hover Action Bar
 */
export let ActionBarMachine = (_dec = observable.shallow, _class = class ActionBarMachine extends BaseMachine {
  /**
   * The function to use to hide the action bar and its menus
   */

  constructor(menuItems, hideFunc) {
    super();
    _initializerDefineProperty(this, "isMouseOver", _descriptor, this);
    /**
     * The menu items to display on the action bar
     */
    _initializerDefineProperty(this, "_menuItems", _descriptor2, this);
    /**
     * The <code>{@link ActionBarMenuMachine}</code> for the popup menu
     */
    _initializerDefineProperty(this, "_menuMachine", _descriptor3, this);
    /**
     * The state of the action bar
     */
    _initializerDefineProperty(this, "_state", _descriptor4, this);
    _initializerDefineProperty(this, "_enabled", _descriptor5, this);
    makeObservable(this);
    this.isMouseOver = undefined;
    this._menuItems = undefined;
    this._menuMachine = undefined;
    this._enabled = true;
    this._state = "open";
    this.setMenuItems(menuItems);
    if (hideFunc) {
      this._hideFunc = hideFunc;
    }
    this.registerDestroyListener(reaction(() => this._menuMachine.isOpen, action("ActionBarMachine._menuMachine.isOpen.action", isOpen => {
      if (isOpen) {
        this._state = "menu_open";
      } else {
        this._state = "open";
        this.isMouseOver = false;
      }
    }), createReactionName("ActionBarMachine._menuMachine.isOpen", false)));
  }
  get enabled() {
    return this._enabled || this.isMouseOver;
  }
  set enabled(value) {
    this._enabled = value;
  }
  get menuMachine() {
    return this._menuMachine;
  }
  get menuBarItems() {
    if (this._menuItems) {
      return this._menuItems.filter(item => ClassUtils.isInstanceOf(item, AbActionBarItem));
    }
    return null;
  }
  get isMenuOpen() {
    return this._state === "menu_open";
  }
  get isMenuOpening() {
    return this._state === "menu_opening";
  }
  setOpening() {
    this._state = "menu_opening";
  }
  setMenuItems(menuItems) {
    this._menuItems = menuItems;
    let popupMenuItems = this.getPopupMenuItems();
    this._menuMachine = new ActionBarMenuMachine(null, popupMenuItems, this.performAction.bind(this));
  }
  async destroy() {
    if (this._menuMachine) {
      return this._menuMachine.destroy().then(() => super.destroy());
    } else {
      return super.destroy();
    }
  }
  getPopupMenuItems() {
    return this.convertSubmenuItemsToMachines(this._menuItems.filter(item => !ClassUtils.isInstanceOf(item, AbActionBarItem)));
  }
  openMenu(x, y) {
    let handle = null;
    if (this._menuItems) {
      this._state = "menu_open";
      handle = this.menuMachine.open(x, y);
      this.isMouseOver = false;
    }
    return handle;
  }
  closeMenu() {
    if (this._state === "menu_open" && this._menuMachine) {
      this._menuMachine.close();
    }
  }
  performAction(item, x, y, target) {
    Assert.assert(!ClassUtils.isInstanceOf(item, AbActionMenuSubmenu), "Found unexpected AbActionMenuSubmenu");

    // If it's a submenu, toggle its state
    if (ClassUtils.isInstanceOf(item, ActionBarMenuMachine)) {
      ActionBarMachine.log(`performAction: ${item.menuItem?.label}`);
      if (item.isOpen) {
        item.close();
      } else {
        item.open(x, y);
      }
    } else {
      // Call the item's code and hide everything
      let menuBarItem = item;
      ActionBarMachine.log(`performAction: ${menuBarItem.label}`);
      if (!menuBarItem.enabled) {
        ActionBarMachine.log(`disabled. doing nothing`);
        return;
      }
      if (menuBarItem.callback) {
        ActionBarMachine.log(`calling callback: ${menuBarItem.callback}`);
        try {
          menuBarItem.callback(target);
          ActionBarMachine.log(`callback succeeded`);
        } finally {
          ActionBarMachine.log(`called callback`);
          this.closeMenu();
          if (this._hideFunc) {
            this._hideFunc();
          }
        }
      }
    }
  }
  convertSubmenuItemsToMachines(items) {
    return items.map(menuItem => {
      if (ClassUtils.isInstanceOf(menuItem, AbActionMenuSubmenu)) {
        return new ActionBarMenuMachine(menuItem, this.convertSubmenuItemsToMachines(menuItem.actions), this.performAction.bind(this));
      }
      return menuItem;
    });
  }
  static log(_) {
    return;
    // console.log(`*** ActionBarMachine: ${_}`);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isMouseOver", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_menuItems", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_menuMachine", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_state", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_enabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "enabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "enabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "menuBarItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "menuBarItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isMenuOpen", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMenuOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isMenuOpening", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMenuOpening"), _class.prototype), _class);
//# sourceMappingURL=ActionBarMachine.js.map
